export default __webpack_public_path__ + "static/media/drag-handle-2.4ae97e21.svg";